import { parseEther, type Address } from 'viem';

export type ChainCrop = {
  key: 'wheat' | 'corn' | 'berry';
  id: bigint;
  name: string;
  subtitle: string;
  image: string;
  seedPrice: bigint;
  growSeconds: number;
  harvestAmount: number;
  valuePoints: number;
  multiplier: string;
  color: string;
};

export const chainCrops: ChainCrop[] = [
  { key: 'wheat', id: 1n, name: '晨光小麦', subtitle: '稳健型', image: '/game-art/crop-wheat-v2.webp', seedPrice: parseEther('5'), growSeconds: 30, harvestAmount: 12, valuePoints: 1, multiplier: '×1.20', color: '#f0bd43' },
  { key: 'corn', id: 2n, name: '黄金玉米', subtitle: '成长型', image: '/game-art/crop-corn-v2.webp', seedPrice: parseEther('15'), growSeconds: 60, harvestAmount: 45, valuePoints: 3, multiplier: '×1.50', color: '#7fcc4a' },
  { key: 'berry', id: 3n, name: '星露莓', subtitle: '稀有型', image: '/game-art/crop-strawberry-v2.webp', seedPrice: parseEther('40'), growSeconds: 90, harvestAmount: 144, valuePoints: 10, multiplier: '×1.80', color: '#f26386' }
];

export const ranchFarmAbi = [
  {
    type: 'function', name: 'paymentToken', stateMutability: 'view', inputs: [],
    outputs: [{ name: '', type: 'address' }]
  },
  {
    type: 'function', name: 'cropInfo', stateMutability: 'view',
    inputs: [{ name: '', type: 'uint256' }],
    outputs: [
      { name: 'seedPrice', type: 'uint256' }, { name: 'growSeconds', type: 'uint64' },
      { name: 'harvestAmount', type: 'uint32' }, { name: 'valuePoints', type: 'uint32' },
      { name: 'active', type: 'bool' }
    ]
  },
  {
    type: 'function', name: 'balanceOfBatch', stateMutability: 'view',
    inputs: [{ name: 'accounts', type: 'address[]' }, { name: 'ids', type: 'uint256[]' }],
    outputs: [{ name: '', type: 'uint256[]' }]
  },
  {
    type: 'function', name: 'isApprovedForAll', stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }, { name: 'operator', type: 'address' }],
    outputs: [{ name: '', type: 'bool' }]
  },
  {
    type: 'function', name: 'setApprovalForAll', stateMutability: 'nonpayable',
    inputs: [{ name: 'operator', type: 'address' }, { name: 'approved', type: 'bool' }], outputs: []
  },
  {
    type: 'function', name: 'plots', stateMutability: 'view',
    inputs: [{ name: '', type: 'address' }, { name: '', type: 'uint256' }],
    outputs: [{ name: 'cropId', type: 'uint32' }, { name: 'plantedAt', type: 'uint64' }, { name: 'readyAt', type: 'uint64' }]
  },
  {
    type: 'function', name: 'buySeeds', stateMutability: 'nonpayable',
    inputs: [{ name: 'cropId', type: 'uint256' }, { name: 'quantity', type: 'uint256' }], outputs: []
  },
  {
    type: 'function', name: 'plant', stateMutability: 'nonpayable',
    inputs: [{ name: 'plotId', type: 'uint256' }, { name: 'cropId', type: 'uint256' }], outputs: []
  },
  {
    type: 'function', name: 'harvest', stateMutability: 'nonpayable',
    inputs: [{ name: 'plotId', type: 'uint256' }], outputs: []
  }
] as const;

export function getFarmAddress() {
  return import.meta.env.VITE_FARM_CONTRACT_ADDRESS as Address | undefined;
}
